import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./container.module.scss";

const Container = forwardRef(({ tag: Tag = "div", className, children }, ref) => {
  return <Tag ref={ref} className={classNames(styles["container"], className)}>{children}</Tag>;
});

Container.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tag: PropTypes.string,
};

export default Container;
